import dayjs from 'dayjs';

export const convertGiftRequests = data => {
  const count = data.itemsOnPage.filter(v => v.active)?.[0]?.value;

  const params = new URLSearchParams();

  params.append('page', data.page);
  params.append('count', count);
  params.append('requested_from', dayjs(data.beginDate).format('YYYY-MM-DD'));
  params.append('requested_to', dayjs(data.endDate).add(1, 'day').format('YYYY-MM-DD'));
  if (data.username) params.append('username', data.username);
  const statuses = data.statuses.join('%');
  params.append('status', statuses);
  // data.statuses.forEach(v =>  params.append('status', v));

  return params;

  return {
    page: data.page,
    count,
    statuses: data.statuses,
    requested_from: dayjs(data.beginDate).format('YYYY-MM-DD'),
    requested_to: dayjs(data.endDate).format('YYYY-MM-DD'),
    username: data.username,
  };
};
